import * as API from './'

export default {
  fetchPermission: params => {
    return API.GET('/internship/api/findMenus')
  }
}



// WEBPACK FOOTER //
// ./src/api/permission.js